import { SelectOption } from '@navstation-portal/shared/data-model/common';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { createFormStoreEvents } from '../../create-form-store-events';

export const offshoreConsumptionsFormEvents = createFormStoreEvents('offshoreConsumptionsFormStore');

export const offshoreConsumptionsEvents = eventGroup({
  source: 'offshoreConsumptionsFormStore',
  events: {
    updateFuelSpec: type<{
      index: number;
      isoGrade?: SelectOption;
      lcv?: number;
      sulphur?: number;
      density?: number;
      fuelTemp?: number;
      viscosity?: number;
    }>(),
    clearFuelSpec: type<number>(),
    addFuelSpec: type<void>(),
    removeFuelSpec: type<number | undefined>(),
  },
});
